// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocale } from 'shared_services/redux/hooks/useLocale';
import { parseNumberToLocaleString } from 'shared_services/riseart/utils/Utils';

type Props = {
  totalItems: number,
};

/**
 * InfinitePaginationCounter
 *
 * @param {Props} props
 */
export const InfinitePaginationCounter = ({ totalItems }: Props) => {
  const { name: locale } = useLocale() || {};

  return (
    <FormattedMessage
      id="components.pagination.infiniteCounter"
      values={{
        count: totalItems || 0,
        countFormatted: parseNumberToLocaleString(totalItems || 0, locale),
      }}
    >
      {(text: string) => text}
    </FormattedMessage>
  );
};
